import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { MatrixSchema, TraceMatrixCreatorProps } from "@/types";
import { artifactStore, traceStore, useVModel } from "@/hooks";
import {
  ArtifactTypeInput,
  FlexBox,
  IconButton,
  AttributeChip,
  TextButton,
  PanelCard,
} from "@/components/common";


/**
 * Creates an array of trace matrices.
 */
const __default__ = {
  name: "TraceMatrixCreator",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;



const model = useVModel(props, "modelValue");

/**
 * Returns displayable characteristics on a matrix of artifacts.
 * @param matrix - The matrix to get details for.
 */
function getMatrixDetails(matrix: MatrixSchema): string[] {
  const sources = artifactStore.getArtifactsByType(matrix.source) || [];
  const targets = artifactStore.getArtifactsByType(matrix.target) || [];
  const manual = traceStore.getTraceLinksByArtifactSets(sources, targets, [
    "manual",
  ]);
  const approved = traceStore.getTraceLinksByArtifactSets(sources, targets, [
    "approved",
  ]);

  return [
    manual.length === 1 ? "1 Manual Link" : `${manual.length} Manual Links`,
    approved.length === 1
      ? "1 Approved Link"
      : `${approved.length} Approved Links`,
  ];
}

/**
 * Creates a new trace matrix.
 */
function handleCreateMatrix(): void {
  model.value.push({ source: "", target: "" });
}

/**
 * Removes a matrix from the list.
 * @param idx - The matrix index to remove.
 */
function handleRemoveMatrix(idx: number) {
  model.value = model.value.filter(
    (_: MatrixSchema, currentIdx: number) => currentIdx !== idx
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(model), (matrix, idx) => {
      return (_openBlock(), _createBlock(_unref(PanelCard), {
        key: idx,
        class: "q-my-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            "full-width": "",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FlexBox), {
                column: "",
                "full-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FlexBox), {
                    "full-width": "",
                    b: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArtifactTypeInput), {
                        modelValue: matrix.source,
                        "onUpdate:modelValue": ($event: any) => ((matrix.source) = $event),
                        "show-count": "",
                        label: "Child Type",
                        class: "q-mr-md width-50"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_unref(ArtifactTypeInput), {
                        modelValue: matrix.target,
                        "onUpdate:modelValue": ($event: any) => ((matrix.target) = $event),
                        "show-count": "",
                        label: "Parent Type",
                        class: "width-50"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(FlexBox), {
                    "full-width": "",
                    justify: "center"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMatrixDetails(matrix), (detail) => {
                        return (_openBlock(), _createBlock(_unref(AttributeChip), {
                          key: detail,
                          value: detail,
                          icon: "trace"
                        }, null, 8, ["value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(IconButton), {
                icon: "delete",
                color: "negative",
                tooltip: "Remove trace matrix",
                class: "q-ml-md",
                onClick: ($event: any) => (handleRemoveMatrix(idx))
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_unref(FlexBox), { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_unref(TextButton), {
          text: "",
          label: "Add New Matrix",
          icon: "add",
          onClick: handleCreateMatrix
        })
      ]),
      _: 1
    })
  ]))
}
}

})